'use strict';

angular.module('clientDashboardApp').filter('phoneNumber', function () {
    return function (phoneNumber) {
        //Undefined phone number
        if (!phoneNumber) {
            return '';
        }

        //Phone number has unknown characters
        if (!/^\d+$/.test(phoneNumber)) {
            return phoneNumber;
        }

        //For now since we do not have useful information like the country code we just do a best efforts for the simple cases.
        var formattedNumber;
        if (phoneNumber.length === 10) {
            formattedNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        }else{
            formattedNumber = phoneNumber;
        }

        return formattedNumber;
    };
});
